import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DamoAuthComponent } from '@damotech/damoauth-lib';
import { filter, Subscription, take } from 'rxjs';
import { AppAuthService } from '../app-auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  standalone: true,
  imports: [DamoAuthComponent],
})
export class AuthComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  private readonly authService = inject(AppAuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    console.log('AuthComponent initialized, checking authentication status');
    this.subscription?.unsubscribe();
    this.subscription = this.authService
      .onUserReady()
      .pipe(
        filter((isReady) => isReady),
        take(1),
      )
      .subscribe(async () => {
        console.log('Authenticated, redirecting to dashboard');
        document.getElementById('initial-loading')?.remove();
        await this.router.navigate(['/dashboard']);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
